import {getEquipmentGroups, getEquipmentTypes} from "../assets/constants";

/*
 * Доля стендов (ТЗ 237): иерархия товарная группа → вид продукции.
 * Подсчёт зеркалит backend getBrandsCnt: наши = кол-во коллекций, конкуренты = qnt ?? 1.
 * «значение стендов» = found + competitor; «доля» = % от общего числа стендов.
 */

const emptyBucket = () => ({found: 0, competitor: 0})

const bucketTotal = (bucket) =>
    (((bucket && bucket.found) * 1) || 0) + (((bucket && bucket.competitor) * 1) || 0)

export const formatSharePercent = (count, total) => {
    if (!total) return '0%'
    return (count / total * 100).toFixed(2).replace('.', ',') + '%'
}

/*
 * items — last_monitoring.items
 * → { byGroup, byType, byGroupType: {groupId: {typeId: {found, competitor}}} }
 */
export const calcStandsShare = (items) => {
    const byGroup = {}
    const byType = {}
    const byGroupType = {}

    ;(items || []).forEach((product) => {
        if (!product) return
        const groupId = product.group_id ?? 0
        const typeId = product.type_id ?? 0

        if (!byGroup[groupId]) byGroup[groupId] = emptyBucket()
        if (!byType[typeId]) byType[typeId] = emptyBucket()
        if (!byGroupType[groupId]) byGroupType[groupId] = {}
        if (!byGroupType[groupId][typeId]) byGroupType[groupId][typeId] = emptyBucket()

        if (product.is_competitor) {
            const qnt = (product.qnt * 1) || 1
            byGroup[groupId].competitor += qnt
            byType[typeId].competitor += qnt
            byGroupType[groupId][typeId].competitor += qnt
        } else {
            const cnt = product.collections ? Object.keys(product.collections).length : 0
            byGroup[groupId].found += cnt
            byType[typeId].found += cnt
            byGroupType[groupId][typeId].found += cnt
        }
    })

    return {byGroup, byType, byGroupType}
}

export const mergeStandsStats = (target, source) => {
    Object.keys(source || {}).forEach((id) => {
        if (!target[id]) target[id] = emptyBucket()
        target[id].found += (source[id] && source[id].found * 1) || 0
        target[id].competitor += (source[id] && source[id].competitor * 1) || 0
    })
    return target
}

export const mergeGroupTypeStats = (target, source) => {
    Object.keys(source || {}).forEach((groupId) => {
        if (!target[groupId]) target[groupId] = {}
        mergeStandsStats(target[groupId], source[groupId])
    })
    return target
}

export const hasGroupTypeStats = (groupTypeStats) => {
    return Object.keys(groupTypeStats || {}).some((groupId) =>
        Object.values(groupTypeStats[groupId] || {}).some((bucket) => bucketTotal(bucket) > 0)
    )
}

/*
 * Строки иерархической таблицы для UI:
 * [{kind:'group'|'type'|'total', id, name, count, share, children?}]
 */
export const buildStandsShareRows = (groupTypeStats, groupsMap, typesMap) => {
    const groups = groupsMap || getEquipmentGroups()
    const types = typesMap || getEquipmentTypes()
    const rows = []
    let grandTotal = 0

    Object.keys(groupTypeStats || {}).forEach((groupId) => {
        Object.values(groupTypeStats[groupId] || {}).forEach((bucket) => {
            grandTotal += bucketTotal(bucket)
        })
    })

    if (!grandTotal) return {rows: [], grandTotal: 0}

    Object.keys(groupTypeStats || {}).forEach((groupId) => {
        const typeMap = groupTypeStats[groupId] || {}
        const typeRows = []
        let groupCount = 0

        Object.keys(typeMap).forEach((typeId) => {
            const count = bucketTotal(typeMap[typeId])
            if (!count) return
            groupCount += count
            typeRows.push({
                kind: 'type',
                id: `${groupId}-${typeId}`,
                name: types[typeId] || types[0] || 'Не указан',
                count,
                share: formatSharePercent(count, grandTotal),
            })
        })

        if (!groupCount) return

        rows.push({
            kind: 'group',
            id: `g-${groupId}`,
            name: groups[groupId] || groups[0] || 'Не указан',
            count: groupCount,
            share: formatSharePercent(groupCount, grandTotal),
            children: typeRows,
        })
    })

    return {rows, grandTotal}
}

/* HTML-кнопка «ДОЛЯ ВИДОВ СТЕНДОВ» для Yandex balloon */
export const standsShareBalloonButtonHtml = (token) => {
    if (!token) return ''
    return `<button type="button"
        class="stands-share-balloon-btn"
        data-stands-share-token="${String(token).replace(/"/g, '')}"
        style="margin-top:10px;width:100%;padding:8px 12px;border:2px solid #e64646;background:#fff;color:#e64646;font-weight:700;font-size:13px;cursor:pointer;text-transform:uppercase;">
        ДОЛЯ ВИДОВ СТЕНДОВ
    </button>`
}

export const STANDS_SHARE_MESSAGE = 'openStandsShareReport'
